export const SET_MOBILE_TELEPHONY_MAIN_OPTION = 'SET_MOBILE_TELEPHONY_MAIN_OPTION';
export const SET_MOBILE_TELEPHONY_SUB_OPTION = 'SET_MOBILE_TELEPHONY_SUB_OPTION';
export const RESET_MOBILE_TELEPHONY_OPTIONS = 'RESET_MOBILE_TELEPHONY_OPTIONS';
export const SET_MOBILE_TELEPHONY_COMMENTS = 'SET_MOBILE_TELEPHONY_COMMENTS';

export const setMainOption = (mainOption) => ({
    type: SET_MOBILE_TELEPHONY_MAIN_OPTION,
    payload: mainOption,
});

export const setSubOption = (subOption) => ({
    type: SET_MOBILE_TELEPHONY_SUB_OPTION,
    payload: subOption,
});

export const setComments = (comments) => ({
    type: SET_MOBILE_TELEPHONY_COMMENTS,
    payload: comments,
});

export const resetOptions = () => ({
    type: RESET_MOBILE_TELEPHONY_OPTIONS,
});
